/**
 * Advertencias sobre lo que MUESTRA un campo, publicadas por el backend en el catálogo
 * (`FIELD_CAVEATS` de `form-data`, card ctbIdOOc): `{fieldId: [código, …]}`.
 *
 * El backend manda CÓDIGOS y el texto vive acá, en los dos idiomas (`informes.caveats.<CÓDIGO>`):
 * un código que el front no conoce no se muestra (mejor ningún aviso que uno sin texto).
 *
 * - APPROXIMATE: el desglose es aproximado y la suma de sus filas no coincide con el Total (LinkedIn
 *   descarta los países/regiones con menos de 3 eventos). Hoy: LinkedIn Ads - País / Región.
 * - CONVERSIONS_ARE_TOTAL: con ese desglose, las conversiones son las del sitio que informa la
 *   plataforma y no los eventos elegidos en la línea (review C-ctbidooc-02). Hoy: los mismos dos.
 */
export const CAVEAT_APPROXIMATE = 'APPROXIMATE';
export const CAVEAT_CONVERSIONS_ARE_TOTAL = 'CONVERSIONS_ARE_TOTAL';

export const KNOWN_CAVEATS = [CAVEAT_APPROXIMATE, CAVEAT_CONVERSIONS_ARE_TOTAL];

/** Los códigos conocidos de un campo, o `[]`. Tolera un catálogo viejo sin `FIELD_CAVEATS`. */
export function caveatsOfField(fieldsData, fieldId) {
    const byField = (fieldsData && fieldsData.FIELD_CAVEATS) || {};
    return (byField[fieldId] || []).filter((code) => KNOWN_CAVEATS.includes(code));
}

/** Los códigos de un conjunto de campos, sin repetir y en el orden en que aparecen. */
export function caveatsOfFields(fieldsData, fieldIds) {
    const codes = [];
    (fieldIds || []).forEach((fieldId) => {
        caveatsOfField(fieldsData, fieldId).forEach((code) => {
            if (!codes.includes(code)) codes.push(code);
        });
    });
    return codes;
}

/** Los códigos de las DIMENSIONES de una tabla del Explorador, leídos de sus encabezados. */
export function caveatsOfTableHeaders(fieldsData, headers) {
    const dimensionIds = (headers || [])
        .filter((header) => header && typeof header.key === 'string' && header.key.startsWith('dimension_'))
        .map((header) => header.key.replace(/^dimension_/, ''));
    return caveatsOfFields(fieldsData, dimensionIds);
}
